export default class FormSimulate {
  // static submit(method, action, inputs, appendTo = 'body', turbo = false, target = undefined, turboStream = false, turboFrame){
  static submit(opts){
    const defaultOpts = {
      method: 'post',
      action: undefined,
      inputs: undefined,
      appendTo: 'body',
      turbo: false,
      target: undefined,
      turboStream: false,
      turboFrame: undefined
    }
    const { method, action, inputs, appendTo, turbo, target, turboStream, turboFrame } = Object.assign(defaultOpts, opts);
    console.log(Object.assign(defaultOpts, opts))
    const authenticity_token = document.querySelector('meta[name="csrf-token"]').attributes['content'].textContent;
    const $form = $(`<form class="hidden" method="post" action="${action}" ${turboStream ? "data-turbo-stream=\"true\"" : ''} ${turboFrame ? `data-turbo-frame="${turboFrame}"` : ''} data-turbo="${!!turbo ? 'true' : 'false'}" ${!!target ? `target="${target}"` : ''}></form>`);
    const $button = $('<button class="d-none"></button>');
    $form.append(`<input type="hidden" name="authenticity_token" value="${authenticity_token}">`);
    $form.append(`<input type="hidden" name="_method" value="${method}">`);
    $form.append($button);

    !!inputs && [...[inputs]].flat().forEach(($el) => {
      if (typeof $el === 'string') {
        $form.append($el)
      } else {
        !!$el && $form.append($($el.cloneNode(true)));
      }
    });

    $(appendTo || 'body').append($form);
    $button.trigger('click');

    if (!turboFrame)
      return true;

    return $form.remove();
  }
}